import type { MessageKey } from '@bitwize/i18n-messages';

export interface NavItem {
  /** Path without the locale prefix — `localePath` adds it. */
  path: string;
  labelKey: MessageKey;
}

/**
 * The header's navigation: three places, and the call to action beside them.
 *
 * Short on purpose. Studios and consultancies worth studying keep the header to
 * four to six labels and put everything else in the footer; six links plus a
 * button was a row nobody read. What a visitor most wants — the work, what we
 * do, who we are — is here, and "Start a project" is the button.
 *
 * Static in M0. From M3 it is driven by the Website Settings screen, so that
 * hiding a section removes it from the navigation, the sitemap and the search
 * index together rather than leaving a linked page nobody meant to publish.
 */
export const PRIMARY_NAV: readonly NavItem[] = [
  { path: '/projects', labelKey: 'nav.primary.portfolio' },
  { path: '/services', labelKey: 'nav.primary.services' },
  { path: '/team', labelKey: 'nav.primary.team' },
];

/**
 * Everything reachable from the footer, in two labelled columns. Technologies,
 * the FAQ and the contact page live here rather than in the header: they are
 * where a visitor goes once they are already interested.
 */
export const FOOTER_NAV: readonly { headingKey: MessageKey; items: readonly NavItem[] }[] = [
  {
    headingKey: 'common.footer.navigate',
    items: [...PRIMARY_NAV, { path: '/technologies', labelKey: 'nav.primary.technologies' }],
  },
  {
    headingKey: 'common.footer.company',
    items: [
      { path: '/faq', labelKey: 'nav.primary.faq' },
      { path: '/contact', labelKey: 'nav.primary.contact' },
    ],
  },
];
